/* // global CONFIG */
import moment from 'moment'

export default {
  getQuote (VueApp, forceQuote) {
    let self = this
    let rsvpEdit = VueApp.$store.state.rsvpEdit
    let pickupDate = moment(rsvpEdit.editedRsvp.pickupTime, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD')
    let params = {
      brandId: rsvpEdit.editedRsvp.brandID,
      pickupDate: pickupDate,
      pickup: {
        lat: rsvpEdit.editedRsvp.pickup.lat,
        lng: rsvpEdit.editedRsvp.pickup.lng
      },
      dropoff: {
        lat: rsvpEdit.editedRsvp.dropoff.lat,
        lng: rsvpEdit.editedRsvp.dropoff.lng
      }
    }
    if (rsvpEdit.editedRsvp.hasExtraStop && rsvpEdit.editedRsvp.extraStops.length) {
      rsvpEdit.editedRsvp.extraStops.forEach(stop => {
        if (!params.extraStops) { params.extraStops = [] }
        params.extraStops.push({
          lat: stop.lat,
          lng: stop.lng
        })
      })
    }
    let charter = VueApp.$store.state.reservation.charter
    if (charter.enabled) {
      let startDate = moment(charter.startDate, 'MM/DD/YYYY hh:mmA')
      let endDate = moment(charter.endDate, 'MM/DD/YYYY hh:mmA')
      let duration = moment.duration(endDate.diff(startDate))
      params = {
        brandId: rsvpEdit.editedRsvp.brandID,
        pickupDate: startDate.format('YYYY-MM-DD'),
        etaInSec: duration.asSeconds(),
        pickup: {
          lat: rsvpEdit.editedRsvp.pickup.lat,
          lng: rsvpEdit.editedRsvp.pickup.lng
        },
        isCharter: true
      }
    }

    VueApp.$store.commit('rsvpEdit/setQuotationLoading', true)
    let originalRsvp = VueApp.$store.state.rsvpEdit.originalRsvp
    let editedRsvp = VueApp.$store.state.rsvpEdit.editedRsvp

    let isPickupSame = false
    if ((originalRsvp.pickup.geofenceType === 'airport' && originalRsvp.pickup.geofenceId === editedRsvp.pickup.geofenceId) ||
    (originalRsvp.pickup.geofenceType !== 'airport' && originalRsvp.pickup.title === editedRsvp.pickup.title)
    ) {
      isPickupSame = true
    }

    let isDropoffSame = false
    if ((originalRsvp.dropoff.geofenceType === 'airport' && originalRsvp.dropoff.geofenceId === editedRsvp.dropoff.geofenceId) ||
    (originalRsvp.dropoff.geofenceType !== 'airport' && originalRsvp.dropoff.title === editedRsvp.dropoff.title)
    ) {
      isDropoffSame = true
    }

    let isExtraStopSame = false
    if (!originalRsvp.extraStops && !editedRsvp.extraStops) {
      isExtraStopSame = true
    }
    if (originalRsvp.extraStops && editedRsvp.extraStops &&
      originalRsvp.extraStops.length === editedRsvp.extraStops.length
      ) {
      isExtraStopSame = true
      originalRsvp.extraStops.forEach((stop, index) => {
        if (stop.lat !== editedRsvp.extraStops[index].lat ||
          stop.lng !== editedRsvp.extraStops[index].lng
          ) {
          isExtraStopSame = false
        }
      })
    }

    if (isPickupSame && isDropoffSame && isExtraStopSame && !forceQuote) {
      VueApp.$sdk.post(VueApp, '/reservations/' + pickupDate, params, res => {
        let extraService = {}
        if (!res.error) {
          for (let service in res.services) {
            if (res.services[service].code === originalRsvp.serviceCode) {
              extraService = {
                code: originalRsvp.serviceCode,
                value: {
                  id: res.services[service].id,
                  code: res.services[service].code,
                  brandedName: res.services[service].brandedName,
                  maxLuggage: res.services[service].maxLuggage,
                  maxPassengers: res.services[service].maxPassengers,
                  curbside: res.services[service].curbside,
                  meetAndGreet: res.services[service].meetAndGreet,
                  pickupFee: res.services[service].pickupFee,
                  prices: res.services[service].oneway,
                  roundtrip: res.services[service].roundtrip,
                  status: res.services[service].status,
                  airportFee: res.services[service].airportFee,
                  travelInsurance: res.services[service].travelInsurance,
                  isShared: res.services[service].code === 'shared'
                }
              }
            }
          }
          self.getNewQuote(VueApp, params, extraService)
        } else {
          self.getNewQuote(VueApp, params, false)
        }
      })
    } else {
      self.getNewQuote(VueApp, params, false)
    }
  },
  getNewQuote (VueApp, params, extraService) {
    let charter = VueApp.$store.state.reservation.charter
    let self = this
    params.order = 'priority'
    let rsvpEdit = VueApp.$store.state.rsvpEdit.editedRsvp
    let serviceSelection = VueApp.$store.state.rsvpEdit.serviceSelection.selectedService
    let code = serviceSelection ? serviceSelection.code : rsvpEdit.serviceCode
    params.pickupTime = moment(rsvpEdit.pickupTime, 'MM/DD/YYYY hh:mmA').format('HH:mm:ss')
    let quoteUrl = params.isCharter ? '/quotation/charter' : '/quotation'
    let timeNow = moment()
    if (rsvpEdit.discountCode) params.discountCode = rsvpEdit.discountCode
    VueApp.$sdk.post(VueApp, quoteUrl, params, r => {
      self.sendQuoteTime(VueApp, timeNow, moment(), r.quoteId, params)
      VueApp.$store.commit('rsvpEdit/setQuotationLoading', false)
      if (r.error) {
        // TODO show error message
        return
      }

      // Service Prices
      let services = {}
      let serviceExist = false
      r.services.forEach(service => {
        services['a' + service.serviceType.id] = self.buildServiceData(VueApp, service)
        if (code === `a${service.serviceType.id}` && !service.unavailableTime) {
          serviceExist = true
        }
      })
      if (!serviceExist) {
        VueApp.$store.commit('rsvpEdit/setSelectedService', null)
        VueApp.$store.commit('rsvpEdit/emptyEditedService', '')
      }
      VueApp.$store.commit('rsvpEdit/setServices', services)
      if (extraService && Object.keys(extraService).length > 0) {
        VueApp.$store.commit('rsvpEdit/addService', extraService)
      }

      // update pickup geofence
      let pickup = VueApp.$store.state.rsvpEdit.editedRsvp.pickup
      let pickupGeofence = {}
      if (!params.isCharter) {
        pickupGeofence = r.geofences.pickup
        pickup.geofenceId = pickupGeofence.id
        pickup.geofenceType = pickupGeofence.type
        pickup.geofenceName = pickupGeofence.name
        // pickup.airportCode = 'LAX'
      }
      if (params.isCharter) {
        pickupGeofence = {
          id: r.geofence.id,
          type: r.geofence.type,
          name: r.geofence.name,
          airportCode: 'LAX'
        }
        if (r.airport && r.airport.id) {
          pickupGeofence.type = 'airport'
          pickupGeofence.airportCode = r.airport.airportCode
          pickupGeofence.name = r.airport.name
          VueApp.$store.commit('reservation/setCharterData', {airportGeoId: r.airport.id})
        }
        pickup.geofenceId = pickupGeofence.id
        pickup.geofenceType = pickupGeofence.type
        pickup.geofenceName = pickupGeofence.name
        pickup.airportCode = pickupGeofence.airportCode
      }

      // update dropoff geofence
      let dropoff = VueApp.$store.state.rsvpEdit.editedRsvp.dropoff
      let dropoffGeofence = {}
      if (!params.isCharter) {
        dropoffGeofence = r.geofences.dropoff
        dropoff.geofenceId = dropoffGeofence.id
        dropoff.geofenceType = dropoffGeofence.type
        dropoff.geofenceName = dropoffGeofence.name
        // dropoff.airportCode = 'LAX' // airportCodeLastroy
        VueApp.$store.commit('rsvpEdit/setEditedDropoff', dropoff)
      }

      // check airlines
      if (pickupGeofence.type === 'airport' || dropoffGeofence.type === 'airport') {
        let geofenceId = pickupGeofence.id
        if (pickupGeofence.type !== 'airport' || dropoffGeofence.type === 'airport') {
          geofenceId = dropoffGeofence.id
        }
        if (params.isCharter) {
          geofenceId = charter.airportGeoId
        }
        VueApp.$sdk.get(VueApp, '/geofences/' + geofenceId + '/airlines', {}, res => {
          if (res.error) { return }
          VueApp.$store.commit('rsvpEdit/setAirlines', res.list)
        })
      }

      // set routing info
      VueApp.$store.commit('rsvpEdit/setEditedDistance', params.isCharter ? 0 : r.route.distance)
      VueApp.$store.commit('rsvpEdit/setEditedETA', params.isCharter ? params.etaInSec : r.route.eta.sec)

      self.updateSelectedService(VueApp)
    }, '2.0')
  },
  buildServiceData (VueApp, data) {
    let oneway = []
    let roundtrip = []
    let charter = VueApp.$store.state.reservation.charter
    if (!charter.enabled) {
      let dcEnabled = data.settings.discountWidget
      for (let i = 0; i < data.serviceType.maxPassengers; i++) {
        data.oneway[i].price = parseFloat(dcEnabled ? data.oneway[i].price : data.oneway[i].original)
        data.oneway[i].original = parseFloat(data.oneway[i].original)
        data.roundtrip[i].price = parseFloat(dcEnabled ? data.roundtrip[i].price : data.roundtrip[i].original)
        data.roundtrip[i].original = parseFloat(data.roundtrip[i].original)
        if (!dcEnabled) {
          data.oneway[i].discount = 0
          data.roundtrip[i].discount = 0
        }
        oneway.push(data.oneway[i])
        roundtrip.push(data.roundtrip[i])
      }
    } else {
      for (let i = 0; i < data.serviceType.maxPassengers; i++) {
        oneway.push(data.fare)
      }
    }

    let curbside = false
    let meetAndGreet = false
    let meetAndGreetFee = 0

    let curbsideIndex = data.pickupTypes.findIndex(x => x.name === 'Curbside')
    if (curbsideIndex > -1 && data.pickupTypes[curbsideIndex].enabled) {
      curbside = true
    }

    let meetAndGreetIndex = data.pickupTypes.findIndex(x => x.name === 'MeetAndGreet')
    if (meetAndGreetIndex > -1 && data.pickupTypes[meetAndGreetIndex].enabled) {
      meetAndGreet = true
      meetAndGreetFee = data.pickupTypes[meetAndGreetIndex].fee
    }

    let availabilityInfo = false
    if (data.serviceType.useShifts) {
      availabilityInfo = data.availability
    }

    let bufferTime = data.serviceType.bufferWidgetMins
    if (!data.serviceType.bufferWidgetMins && VueApp.$store.state.reservation.webTimeBuffer) {
      bufferTime = VueApp.$store.state.reservation.webTimeBuffer
    }

    return {
      id: data.serviceType.id,
      code: 'a' + data.serviceType.id,
      brandedName: data.serviceType.name,
      maxLuggage: data.serviceType.maxLuggages,
      maxPassengers: data.serviceType.maxPassengers,
      curbside: curbside,
      meetAndGreet: meetAndGreet,
      pickupFee: meetAndGreetFee,
      prices: oneway,
      roundtrip: roundtrip,
      isShared: data.serviceType.isShared,
      status: 'allowed',
      airportFee: data.settings.airportFee,
      travelInsurance: data.settings.travelInsurance || 0,
      img: data.serviceType.image,
      availabilityInfo: availabilityInfo,
      gasFee: data.settings.gasFee || 0,
      optinAllow: data.serviceType.optinAllow,
      optinPercent: data.serviceType.optinPercent || 1,
      unavailableTime: data.unavailableTime,
      bufferTime: bufferTime
    }
  },
  updateSelectedService (VueApp) {
    let services = VueApp.$store.state.rsvpEdit.serviceSelection.services
    if (services === null) {
      return
    }
    let self = this
    let original = VueApp.$store.state.rsvpEdit.originalRsvp
    let edited = VueApp.$store.state.rsvpEdit.editedRsvp
    let selectedService = VueApp.$store.state.rsvpEdit.serviceSelection.selectedService
    let serviceCode = selectedService !== null ? selectedService.code : edited.serviceCode
    let didServiceTypeChange = original.serviceCode !== serviceCode
    let didPassengerChange = original.passengers !== edited.passengers
    let didPickupChange = self.didLocationChange(original.pickup, edited.pickup)
    let didDropoffChange = self.didLocationChange(original.dropoff, edited.dropoff)
    let didPickupDateChange = self.didPickupChange(VueApp, original.pickupTime, edited.pickupTime)

    let oldExtraStops = original.extraStops
    let newExtraStops = edited.extraStops
    let hasExtraStopChanges = false
    if (oldExtraStops && oldExtraStops.length) {
      if (oldExtraStops.length !== newExtraStops.length) {
        hasExtraStopChanges = true
      } else {
        oldExtraStops.forEach((stop, index) => {
          if (stop.lat !== newExtraStops[index].lat || stop.lng !== newExtraStops[index].lng) {
            hasExtraStopChanges = true
          }
        })
      }
    } else if (newExtraStops && newExtraStops.length) {
      hasExtraStopChanges = true
    }

    if ((didServiceTypeChange || didPassengerChange || didPickupChange || didDropoffChange || didPickupDateChange) && services[serviceCode] || hasExtraStopChanges) {
      VueApp.$store.commit('rsvpEdit/setSelectedService', services[serviceCode])
    } else {
      VueApp.$store.commit('rsvpEdit/setSelectedService', null)
    }

    let pickupFee = 0
    if (edited.pickupType === 'meetAndGreet') {
      pickupFee = services[serviceCode].pickupFee
    }

    VueApp.$store.commit('rsvpEdit/setEditedPickupFee', pickupFee)
  },
  didPickupChange (VueApp, original, edited) {
    let holiday = VueApp.$store.state.rsvpEdit.serviceSelection.holiday
    if (holiday === null) {
      return false
    }
    let holidayDate = holiday.date
    let originalPickup = moment(original, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD')
    let editedPickup = moment(edited, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD')
    let isOriginalHoliday = originalPickup === holidayDate
    let isEditedHoliday = editedPickup === holidayDate
    return isOriginalHoliday !== isEditedHoliday
  },
  didLocationChange (original, edited) {
    if (original.lat !== edited.lat || original.lng !== edited.lng) {
      return true
    }
    return false
  },
  sendQuoteTime (VueApp, start, end, quoteId, param) {
    let store = VueApp.$store.state
    let duration = end.diff(start, 'milliseconds') / 1000
    VueApp.$sdk.opt('/quotation/time', {
      token: store.user.token,
      brandId: store.brandId,
      quotationId: quoteId,
      responseTime: duration,
      deviceType: 'ww',
      data: JSON.stringify(param)
    }, res => {
      if (res.error) console.log('ERROR quotation time')
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/edit-quote.js